// extracted by mini-css-extract-plugin
export var member = "team-module--member--AoOJe";
export var members = "team-module--members--dASGa";
export var team = "team-module--team--C2q8r";